"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./PricingCards.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PricingCard = _ref => {
  let {
    content,
    selected,
    setSelected
  } = _ref;
  const {
    title,
    price,
    currency,
    discount,
    terms,
    discountAmount,
    priceDescription,
    sku
  } = content;
  const updateCardSelection = sku => {
    setSelected(sku);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-pricing-card ${selected === sku ? "ter-pricing-card--selected" : ""}`,
    onClick: () => updateCardSelection(sku)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__header"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__title"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__term"
  }, "\u2022 ", terms)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__price-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__price"
  }, price, " ", currency), discount && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__discount"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-pricing-card__price--strike"
  }, price), " ", /*#__PURE__*/_react.default.createElement("span", null, "Save ", discountAmount)), /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__price-description"
  }, priceDescription))));
};
const PricingCards = _ref2 => {
  let {
    content = {},
    contentfulId,
    selected,
    setSelected
  } = _ref2;
  const {
    cards
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-cards"
  }, cards?.map((card, index) => {
    return /*#__PURE__*/_react.default.createElement(PricingCard, {
      key: `pricing-card-${index}`,
      content: card,
      contentfulId: contentfulId,
      selected: selected,
      setSelected: setSelected
    });
  }));
};
var _default = PricingCards;
exports.default = _default;
PricingCards.propTypes = {
  content: _propTypes.default.shape({
    cards: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      price: _propTypes.default.string,
      currency: _propTypes.default.string,
      discount: _propTypes.default.bool
    }))
  }),
  contentfulId: _propTypes.default.string
};